{
  "Accessibility Menu": "မည်သူမဆို အသုံးပြုနိုင်သော မီနူး",
  "Reset settings": "ဆက်တင်များကို ပြန်လည်သတ်မှတ်ပါ",
  "Close": "ပိတ်ပါ",
  "Content Adjustments": "အကြောင်းအရာ ချိန်ညှိမှုများ",
  "Adjust Font Size": "ဖောင့်အရွယ်အစားကို ချိန်ညှိပါ",
  "Highlight Title": "ခေါင်းစဉ်ကို အထူးပြုပါ",
  "Highlight Links": "လင့်များကို အထူးပြုပါ",
  "Readable Font": "ဖတ်ရန်လွယ်ကူသော ဖောင့်",
  "Color Adjustments": "အရောင် ချိန်ညှိမှုများ",
  "Dark Contrast": "မှောင်မိုက်သော ကွာခြားမှု",
  "Light Contrast": "အလင်းရောင် ကွာခြားမှု",
  "High Contrast": "မြင့်မားသော ကွာခြားမှု",
  "High Saturation": "မြင့်မားသော အရောင်စွဲမှု",
  "Low Saturation": "နိမ့်သော အရောင်စွဲမှု",
  "Monochrome": "တစ်ရောင်တည်း",
  "Tools": "ကိရိယာများ",
  "Reading Guide": "ဖတ်ရှုရန် လမ်းညွှန်",
  "Stop Animations": "အန်နီမေးရှင်းများကို ရပ်ပါ",
  "Big Cursor": "ကြီးမားသော ကာဆာ",
  "Increase Font Size": "ဖောင့်အရွယ်အစားကို တိုးချဲ့ပါ",
  "Decrease Font Size": "ဖောင့်အရွယ်အစားကို လျှော့ချပါ",
  "Letter Spacing": "အက္ခရာအကြား အကွာအဝေး",
  "Line Height": "စာကြောင်းအမြင့်",
  "Font Weight": "ဖောင့်အလေးချိန်",
  "Dyslexia Font": "Dyslexia ဖောင့်",
  "Language": "ဘာသာစကား",
  "Open Accessibility Menu": "မည်သူမဆို အသုံးပြုနိုင်သော မီနူးကို ဖွင့်ပါ",
  "Accessibility Profiles": "အသုံးပြုရလွယ်ကူမှု ပရိုဖိုင်များ",
  "Seizure Safe Profile": "အကြောသက်သာစေသော ပရိုဖိုင်",
  "Stops animations and reduces color saturation.": "အန်နီမေးရှင်းများကို ရပ်ပြီး အရောင်စွဲမှုကို လျှော့ချသည်။",
  "Blind Profile": "အိုမင်း မမြင်နိုင်သူ ပရိုဖိုင်",
  "Activates the screen reader for auditory navigation.": "အသံဖြင့် လမ်းညွှန်မှုအတွက် စကရင်းဖတ်စက်ကို ဖွင့်သည်။",
  "Visually Impaired Profile": "မြင်နိုင်မှု အားနည်းသူ ပရိုဖိုင်",
  "Enhances contrast and readability for low vision.": "မြင်နိုင်မှုနည်းသူများအတွက် ကွာခြားမှုနှင့် ဖတ်ရလွယ်ကူမှုကို တိုးတက်စေသည်။",
  "ADHD Friendly Profile": "ADHD အတွက် သင့်လျော်သော ပရိုဖိုင်",
  "Reduces distractions for better focus.": "အာရုံစူးစိုက်မှုအတွက် ဆွဲဆောင်မှုများကို လျှော့ချသည်။",
  "Cognitive & Learning Profile": "အသိဉာဏ်နှင့် သင်ယူမှု ပရိုဖိုင်",
  "Helpful tools for reading and comprehension.": "ဖတ်ရှုခြင်းနှင့် နားလည်မှုအတွက် အကူအညီကိရိယာများ။",
  "Motor Impaired Profile": "လက်နဲ့ ခြေမောင်းချို့တဲ့သူများ ပရိုဖိုင်",
  "Optimizes the site for keyboard-only navigation.": "ကီးဘုတ်သာ အသုံးပြု၍ လမ်းညွှန်ရန်ဆိုက်ကို အကောင်းဆုံး အဆင်ပြေစေသည်။",
  "Headings": "ခေါင်းစဉ်များ",
  "Landmarks": "အထင်ကရ အချက်များ",
  "Links": "လင့်များ",
  "Focus element": "အာရုံစူးစိုက်ရန် အချက်",
  "Visit link": "လင့်သို့ သွားပါ"
}